import type { MutationTree } from 'vuex';
import type { IEntityState } from '@signing-page/entity/store/entity.store';
import type { IEntity } from '@signing-page/entity/types/entity';

export const mutationSetEntity = 'setEntity';

export const mutations: MutationTree<IEntityState> = {
  [mutationSetEntity](state: IEntityState, entity: IEntity) {
    state.entity = entity;
  },
};
